// Remote Server Types for Frontend

export enum RemoteServerType {
  POSTGRES_FDW = 'postgres_fdw',
  STRIPE_FDW = 'stripe_fdw',
}

export type PostgresConnectionOptions = {
  host: string;
  port: number;
  dbname: string;
};

export type StripeConnectionOptions = {
  api_key: string;
  api_url?: string;
};

export type ForeignDataWrapperOptions =
  | PostgresConnectionOptions
  | StripeConnectionOptions;

export type UserMappingOptions = {
  user: string;
  password: string;
};

export type RemoteServer = {
  id: string;
  foreignDataWrapperId: string;
  foreignDataWrapperType: RemoteServerType;
  label: string;
  foreignDataWrapperOptions: ForeignDataWrapperOptions;
  userMappingOptions?: UserMappingOptions;
  schema?: string;
  tenantId: string;
  createdAt: Date;
  updatedAt: Date;
};

export type CreateRemoteServerRequest = {
  foreignDataWrapperType: RemoteServerType;
  label: string;
  foreignDataWrapperOptions: ForeignDataWrapperOptions;
  userMappingOptions?: UserMappingOptions;
  schema?: string;
};

export type UpdateRemoteServerRequest = Partial<CreateRemoteServerRequest>;

export type RemoteServerResponse = RemoteServer;

export type RemoteServerListResponse = {
  servers: RemoteServer[];
  total: number;
};

export type TestConnectionResponse = {
  success: boolean;
  message: string;
  details?: {
    serverType: RemoteServerType;
    connectedAt: Date;
    latencyMs?: number;
  };
};
